import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import FaSpinner from 'react-icons/fa/spinner';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { Row, Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';
import FieldFormControl from '../../../../../../components/FieldFormControl';

interface ILoginFormProps extends InjectedFormProps {
  actions: {
    push: (route: string) => void;
  };
  embed?: boolean;
}

class LoginForm extends React.Component<ILoginFormProps> {
  public static defaultProps: Partial<ILoginFormProps> = {
    embed: false,
  };

  public render() {
    const { handleSubmit, submitting, embed } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} method="post" autoComplete="off">
        {embed && (
          <p>
            We are happy to welcome you again! Please log in to register this new quote in your personal space.
          </p>
        )}
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={7}>
            Email address:
          </Col>
          <Col sm={5}>
            <Field
              id="email"
              name="email"
              type="email"
              placeholder={'email@domain.com'}
              component={FieldFormControl}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={7}>
            Password:
          </Col>
          <Col sm={5}>
            <Field
              id="password"
              name="password"
              type="Password"
              component={FieldFormControl}
              placeholder="Password"
            />
          </Col>
        </FormGroup>
        <div className={'btn-bar login-section' + (this.props.embed ? ' embed' : '')}>
          <Row>
            <Col sm={7}>
              <Link
                disabled={submitting}
                className="btn-secondary back-btn btn"
                to={'/auth/remind'}
              >
                Reset Password
              </Link>
            </Col>
            <Col sm={5}>
              <Button
                type="submit"
                disabled={submitting}
                className="pull-right btn-secondary continue-btn login-btn"
              >
                {submitting ? (
                  <FaSpinner className="fa-spin"/>
                ) : (
                  <span>Log In</span>
                )}
              </Button>
            </Col>
          </Row>
        </div>
      </Form>
    );
  }
}

export default flow([
  reduxForm({
    form: 'login',
  }),
  connect(null,
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(LoginForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/Login/components/LoginForm/index.tsx